import { render, staticRenderFns } from "./Checkerboard.vue?vue&type=template&id=561083b2"
import script from "./Checkerboard.vue?vue&type=script&lang=js"
export * from "./Checkerboard.vue?vue&type=script&lang=js"
import style0 from "./Checkerboard.vue?vue&type=style&index=0&id=561083b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports